import React from 'react';
import PropTypes from 'prop-types';

import TiktokSociablekit, {
  propTypes as tikTokSociablekitPropTypes,
} from '../../../02_molecules/TiktokSociablekit';
import {
  generateClassNameByBehaviorSettings,
  behaviorSettingsProps,
} from '../../../../utils/behaviorSettings';

import styles from './index.module.scss';

const BBSocialMediaFeedEmbed = ({
  widgetProps,
  provider = 'tiktok-sociablekit',
  behaviorSettings = null,
  uuid = null,
}) => {
  const classes = [
    'bb',
    styles['bb-sm-feed'],
    generateClassNameByBehaviorSettings(behaviorSettings),
  ];

  return (
    <div className={classes.join(' ')} id={uuid}>
      <div className="container">
        <div className={styles['bb-sm-feed__content']}>
          {provider === 'tiktok-sociablekit' && <TiktokSociablekit {...widgetProps} />}
        </div>
      </div>
    </div>
  );
};

const propTypes = {
  widgetProps: PropTypes.oneOfType([PropTypes.shape(tikTokSociablekitPropTypes)]).isRequired,
  provider: PropTypes.oneOf(['tiktok-sociablekit']).isRequired,
};

BBSocialMediaFeedEmbed.propTypes = {
  ...propTypes,
  behaviorSettings: behaviorSettingsProps,
  uuid: PropTypes.string,
};

export { propTypes };

export default BBSocialMediaFeedEmbed;
